import { create } from "zustand";

type WizardStep = 1 | 2 | 3;

const INITIAL_STATE = {
  open: false,
  vendorId: null as string | null,
  step: 1 as WizardStep,
  selectedPackageId: null as string | null,
  signerName: "",
  termsScrolled: false,
  termsAccepted: false,
  answers: {} as Record<string, string>,
};

interface ConnectWizardState {
  open: boolean;
  vendorId: string | null;
  step: WizardStep;
  selectedPackageId: string | null;
  signerName: string;
  termsScrolled: boolean;
  termsAccepted: boolean;
  answers: Record<string, string>;

  openWizard: (vendorId: string) => void;
  closeWizard: () => void;
  nextStep: () => void;
  prevStep: () => void;
  setPackageId: (id: string | null) => void;
  setSignerName: (name: string) => void;
  markTermsScrolled: () => void;
  setTermsAccepted: (accepted: boolean) => void;
  setAnswer: (questionId: string, value: string) => void;
  reset: () => void;
}

export const useConnectWizardStore = create<ConnectWizardState>((set) => ({
  ...INITIAL_STATE,

  openWizard: (vendorId) => set({ ...INITIAL_STATE, open: true, vendorId }),
  closeWizard: () => set(INITIAL_STATE),

  nextStep: () =>
    set((s) => ({ step: (Math.min(s.step + 1, 3) as WizardStep) })),
  prevStep: () =>
    set((s) => ({ step: (Math.max(s.step - 1, 1) as WizardStep) })),

  setPackageId: (id) => set({ selectedPackageId: id }),
  setSignerName: (name) => set({ signerName: name }),
  markTermsScrolled: () => set({ termsScrolled: true }),
  setTermsAccepted: (accepted) => set({ termsAccepted: accepted }),

  setAnswer: (questionId, value) =>
    set((s) => ({ answers: { ...s.answers, [questionId]: value } })),

  reset: () => set(INITIAL_STATE),
}));
